import { render, staticRenderFns } from "./ProductAddBuy.vue?vue&type=template&id=48867259&scoped=true&"
import script from "./ProductAddBuy.vue?vue&type=script&lang=js&"
export * from "./ProductAddBuy.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddBuy.vue?vue&type=style&index=0&id=48867259&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48867259",
  null
  
)

export default component.exports